//angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
//other
//app animations
import { toggleLink, toggleButton, toggleLabel, logoAnimation } from 'src/app/_shared/animations';
//app components
import { DialogShortcutsComponent } from '../dialog/shortcuts/shotrcuts.component';
//app const
import { SideNavMenuOptions, ToggleState } from 'src/app/app.data';
//app services
import { StorageService } from 'src/app/_core/services';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [logoAnimation, toggleButton, toggleLabel, toggleLink],
  selector: 'nav-side',
  templateUrl: './nav-side.component.html'
})

export class NavSideComponent implements /* OnInit, */ OnDestroy {
  dialogSearchProduct: MatDialogRef<DialogShortcutsComponent>;
  notificationCount: any;
  routerLinkActive: string;
  userInitials: string;
  userFirstName: string;
  userLastName: string;
  userRole: string;
  private subs = new Unsubscriber();

  @Input() _toggleSideNav = false;
  @Input() _toggleState = ToggleState;
  @Input() _sideNavMenuOptions = SideNavMenuOptions;
  @Input() _sideNavMenuOptionActive: string;

  constructor (
    private _dialog: MatDialog,
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _sanitizer: DomSanitizer,
    private _storage: StorageService
  ) {
    this._iconRegistry.addSvgIcon('ico-add',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-add-04.svg'));
    this._iconRegistry.addSvgIcon('ico-analytics',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-analytics-02.svg'));
    this._iconRegistry.addSvgIcon('ico-channels',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-channels-03.svg'));
    this._iconRegistry.addSvgIcon('ico-customers',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-03.svg'));
    this._iconRegistry.addSvgIcon('ico-dashboard',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-dashboard-03.svg'));
    this._iconRegistry.addSvgIcon('ico-invoices',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-invoices-02.svg'));
    this._iconRegistry.addSvgIcon('ico-next',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-next-01.svg'));
    this._iconRegistry.addSvgIcon('ico-products',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-products-02.svg'));
    this._iconRegistry.addSvgIcon('ico-setup',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-setup-01.svg'));
    this._iconRegistry.addSvgIcon('ico-subscriptions',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-subscriptions-02.svg'));
    this._iconRegistry.addSvgIcon('ico-transactions',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-transactions-01.svg'));
    this._iconRegistry.addSvgIcon('logo-rebillia',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia-02.svg'));

    this.userFirstName = (this._storage.readLocalStorage('userFirstName') != 'null' ? this._storage.readLocalStorage('userFirstName') : '');
    this.userLastName = (this._storage.readLocalStorage('userLastName') != 'null' ? this._storage.readLocalStorage('userLastName') : '');
    this.userInitials = (this.userFirstName != '' ? this.userFirstName.charAt(0) : '') + (this.userLastName != '' ? this.userLastName.charAt(0) : '');
    this.userRole = this._storage.readLocalStorage('userRole');
  }

  showPanelShortcuts() {
    this.dialogSearchProduct = this._dialog.open(DialogShortcutsComponent, {
      panelClass: ['custom-mat-dialog', 'mat-dialog-shortcuts'],
    });
  };

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
